import { useGetFarms, useUserContext } from "utils";

import { resolveSoilSightLocationRegion } from "pages/app/scenario-analysis/utils/scenarioAnalysisHelpers";

/** The region new Soil Sight projects are created in: the current farm's country, else the user's. */
export const useSoilSightLocationRegion = (): string => {
  const { user } = useUserContext();
  const { currentFarm } = useGetFarms();
  return resolveSoilSightLocationRegion({ farmCountry: currentFarm?.country, userCountry: user?.farm?.country });
};
